export default {
	gaTrackingId: 'G-6DPTSXCH00',

	//apiRoot: 'http://130.208.108.18:8095/malid/',
	pageUrl: '/',
	apiRoot: '/api_proxy/'
}



// WEBPACK FOOTER //
// ./src/config.js